export const BF_ERROR_MODAL_KEY = '____bf_error_modal';

export const SPOTLIGHT_TAG = 'Spotlight';
export const EVERGREEN_TAG = 'Evergreen';
